import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { Lock, ArrowRight, ArrowLeft } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_tank-showcase/artifacts/dfuf65tx_exact%20sized%20transaprent%20file.png";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("mutumwa_admin_token", data.token);
      localStorage.setItem("mutumwa_admin_expires", data.expires_at);
      toast.success("Welcome back.");
      nav("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail || "Login failed. Try again.";
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0] grain-overlay flex items-center justify-center px-6 py-16">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md">
        <a
          href="/"
          data-testid="admin-back-home"
          className="link-underline inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#1A2F4C] mb-10"
        >
          <ArrowLeft size={14} /> Back to site
        </a>
        <div className="bg-white border border-[rgba(26,47,76,0.15)] p-10">
          <img src={LOGO} alt="Mutumwa" className="h-14 w-auto mb-8" />
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#8B1E28] mb-3">
            <Lock size={14} /> Admin access
          </div>
          <h1
            data-testid="admin-login-heading"
            className="font-display font-black text-3xl md:text-4xl text-[#1A2F4C] tracking-tight leading-tight"
          >
            Sign in to the <em className="italic font-light">Mutumwa</em> dashboard.
          </h1>
          <form onSubmit={onSubmit} data-testid="admin-login-form" className="mt-10">
            <label className="text-xs uppercase tracking-[0.2em] font-bold text-[#1A2F4C]">
              Password
            </label>
            <input
              type="password"
              required
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="input-editorial"
              placeholder="Enter admin password"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="btn-primary mt-10 w-full justify-center disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"} <ArrowRight size={16} />
            </button>
          </form>
        </div>
        <p className="mt-6 text-xs text-[#4A4E58] text-center">
          Restricted area · Mutumwa staff only
        </p>
      </div>
    </div>
  );
}
